<div class="h-[100vh] bg-white md:bg-[#001DA0] relative fade-in"
    [ngClass]="{'': (service.currentStep() === STEP.TERMS || service.currentStep() === STEP.SELECT_ACCOUNT)}"
    *ngIf="!loading">
    <router-outlet></router-outlet>
    <img class="hidden lg:block absolute right-0 bottom-0" src="/assets/images/login.png" alt="">
</div>
<app-spinner *ngIf="loading" class="fade-in" [title]="loaderCopy.title" [message]="loaderCopy.message"></app-spinner>